import { StorageService } from '../../../services/storage.service';
import { Component, OnInit } from '@angular/core';
import { ToggleService } from './toggle.service';
import { DatePipe } from '@angular/common';
import { CustomizerSettingsService } from '../../../../components/customizer-settings/customizer-settings.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
  currentDate: Date = new Date();
  formattedDate: any = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy');

  userDataAuth: any;

  isToggled = false;

  public environment = environment

  constructor(
      private toggleService: ToggleService,
      private datePipe: DatePipe,
      private storageService: StorageService,
      private router: Router,
      public themeService: CustomizerSettingsService
  ) {
    this.toggleService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {
    this.userDataAuth = this.storageService.getUser();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggle() {
    this.toggleService.toggle();
  }

  toggleSidebarTheme() {
    this.themeService.toggleSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }

  toggleCardBorderTheme() {
    this.themeService.toggleCardBorderTheme();
  }

  toggleHeaderTheme() {
    this.themeService.toggleHeaderTheme();
  }

  toggleCardBorderRadiusTheme() {
    this.themeService.toggleCardBorderRadiusTheme();
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  getRole(role: string) {
    switch (role?.toLowerCase()) {
      case 'manager':
        return 'Coordenador';
      case 'operator':
        return 'Operador';
      default:
        return 'Admin';
    }
  }

  logout(): void {
    this.storageService.clear();
    this.router.navigateByUrl('/authentication/logout');
  }
}
